export default __webpack_public_path__ + "static/media/portfolioValueIcon.8e42e003.svg";